import { useLanguage } from '../../context/LanguageContext';

/**
 * QuickAccessPremium — extraído de Dashboard.jsx en P3.1 sesión 2/4 (feb-2026).
 *
 * Links rápidos a Pipelines IA / Automations IA. Solo Premium + toggle activo.
 * JSX y clases Tailwind IDÉNTICOS al original.
 */
const QuickAccessPremium = ({
  isPremium,
  showSubscriptionWidget,
  latestWorkspaceImage,
  showImageEditor,
  forceInternalWorkspace,
  workspaceImages,
}) => {
  const { language } = useLanguage();

  // Mismas condiciones de visibilidad que en el Dashboard original.
  if (!isPremium || !showSubscriptionWidget) return null;
  if (latestWorkspaceImage) return null;
  if (showImageEditor) return null;
  if (forceInternalWorkspace) return null;
  if (workspaceImages.length !== 0) return null;

  return (
    <div className="flex-shrink-0 px-4">
      <div className="grid grid-cols-1 md:grid-cols-2 gap-4 mt-6">
        <a
          href="/dashboard/pipelines"
          className="border border-slate-700/50 rounded-lg p-4 hover:bg-slate-800/50 transition cursor-pointer"
          data-testid="quick-access-pipelines"
        >
          <h3 className="text-lg font-semibold text-white">Pipelines IA</h3>
          <p className="text-sm text-slate-400">
            {language === 'es'
              ? 'Crear, ejecutar y gestionar pipelines de automatizacion IA.'
              : 'Create, run and manage AI automation pipelines.'}
          </p>
        </a>

        <a
          href="/dashboard/automations"
          className="border border-slate-700/50 rounded-lg p-4 hover:bg-slate-800/50 transition cursor-pointer"
          data-testid="quick-access-automations"
        >
          <h3 className="text-lg font-semibold text-white">
            {language === 'es' ? 'Automatizaciones IA' : 'AI Automations'}
          </h3>
          <p className="text-sm text-slate-400">
            {language === 'es'
              ? 'Configurar steps y acciones dentro de cada pipeline.'
              : 'Configure steps and actions within each pipeline.'}
          </p>
        </a>
      </div>
    </div>
  );
};

export default QuickAccessPremium;
